import {Role, User, UserRole} from "@/data/entities/user/index";

export const getDashboardRole = (user: User): Role => {
    const nonCustomerRole: UserRole[] = user
        .roles
        .filter(({name}) => name !== "ROLE_CUSTOMER")

    if (nonCustomerRole.length === 0)
        throw Error("Unauthorized to use dashboard")

    return nonCustomerRole[0].name;
}